import XButton from '../common/XButton';
import XLoader from '../common/XLoader';
import PartnerSearchBar from '../ui-control/PartnerSearchBar';
import {
  partnerCaseDateClasses,
  partnerCaseEmptyClasses,
  partnerCaseFooterClasses,
  partnerCaseListBodyClasses,
  partnerCaseListClasses,
  partnerCaseListHeaderClasses,
  partnerCaseListTitleClasses,
  partnerCaseNameClasses,
  partnerCaseRowClasses
} from './easyModeClasses';

const EasyModePartnerCaseList = ({
  partnerLabel,
  cases,
  isLoading,
  pageNumber,
  totalPages,
  totalCount,
  hasNextPage,
  hasPreviousPage,
  onSearch,
  onSelectCase,
  onNextPage,
  onPreviousPage,
  onBack
}) => (
  <div className={partnerCaseListClasses}>
    <div className={partnerCaseListHeaderClasses}>
      <span className={partnerCaseListTitleClasses}>{`Choose a case from ${partnerLabel}`}</span>
      <XButton variant="link" onClick={onBack}>
        Back
      </XButton>
    </div>

    <PartnerSearchBar partnerName={partnerLabel} setSearchTerm={onSearch} />

    <div className={partnerCaseListBodyClasses}>
      {isLoading && <XLoader className="my-6!" />}

      {!isLoading && cases.length === 0 && (
        <p className={partnerCaseEmptyClasses}>No cases found</p>
      )}

      {!isLoading &&
        cases.map((partnerCase) => (
          <button
            key={partnerCase.id}
            type="button"
            className={partnerCaseRowClasses}
            onClick={() => onSelectCase({ partnerCase })}
          >
            <span className={partnerCaseNameClasses}>{partnerCase.caseName}</span>
            <span className={partnerCaseDateClasses}>{partnerCase.date}</span>
          </button>
        ))}
    </div>

    {totalCount > 0 && (
      <div className={partnerCaseFooterClasses}>
        <XButton variant="outlinePrimary" onClick={onPreviousPage} disabled={!hasPreviousPage}>
          Prev
        </XButton>
        <span>{`Page ${pageNumber}/${totalPages} | Total ${totalCount}`}</span>
        <XButton variant="outlinePrimary" onClick={onNextPage} disabled={!hasNextPage}>
          Next
        </XButton>
      </div>
    )}
  </div>
);

export default EasyModePartnerCaseList;
